import { Link } from 'react-router-dom';
import { diaYMesCorto, diasQueQuedanDePrueba, fasePrueba, zonaDeLaPrueba } from '@alexiarest/shared';
import { useMe } from '../api/hooks';
import './finPrueba.css';

/**
 * Cuántos días de prueba quedan, siempre a la vista. Los mismos días que
 * cuentan Tu plan, el aviso del Panel y la API (`diasQueQuedanDePrueba`).
 */
export function diasDePrueba(trialEndsAt: string, ahora = Date.now(), zona?: string): number {
  return diasQueQuedanDePrueba(trialEndsAt, ahora, zona);
}

/**
 * La etiqueta de arriba (sección 18 del lienzo, 15 oct 2026):
 * - En prueba, verde: «Prueba gratis · te quedan 9 días · Ver planes».
 * - El último día, ámbar: «Hoy es el último día de tu prueba · Elegir plan».
 * - Sin plan, ámbar: «Tu prueba terminó el 29 oct · Elegir plan».
 * Lleva a «Elige tu plan». Con suscripción, o con el cerrojo Founder puesto,
 * no hay nada que contar.
 */
export function TrialPill({ compacto = false }: { compacto?: boolean }): JSX.Element | null {
  const me = useMe();
  const tenant = me.data?.tenant;
  const fase = fasePrueba(tenant);
  if (!tenant?.trialEndsAt || !fase) return null;
  // En el calendario del restaurante, como la API (`fasePrueba`).
  const dias = diasDePrueba(tenant.trialEndsAt, Date.now(), zonaDeLaPrueba(tenant));
  const ambar = fase === 'ultimo-dia' || fase === 'terminada';
  const largo =
    fase === 'terminada'
      ? `Tu prueba terminó el ${diaYMesCorto(tenant.trialEndsAt)}`
      : fase === 'ultimo-dia'
        ? 'Hoy es el último día de tu prueba'
        : `Prueba gratis · te ${dias === 1 ? 'queda 1 día' : `quedan ${dias} días`}`;
  const corto = fase === 'terminada' ? 'Prueba terminada' : fase === 'ultimo-dia' ? 'Último día' : `${dias} ${dias === 1 ? 'día' : 'días'} de prueba`;
  const accion = fase === 'prueba' ? 'Ver planes' : 'Elegir plan';

  return (
    <Link
      to="/elegir-plan"
      className={`chip-prueba${ambar ? ' chip-prueba--ambar' : ''}${compacto ? ' chip-prueba--compacto' : ''}`}
      title={`${largo}. ${accion}`}
      aria-label={`${largo}. ${accion}`}
      data-fase={fase}
    >
      <span className="chip-prueba__largo">{largo}</span>
      <span className="chip-prueba__corto">{corto}</span>
      <span className="chip-prueba__accion">{accion}</span>
    </Link>
  );
}
